// These two placeholders are instantsearch.js's own internal highlight tags.
// The search client asks Meilisearch for them, and react-instantsearch's
// <Highlight> parses them back out, so they must stay exactly as they are.
export const HIGHLIGHT_PRE_TAG = "__ais-highlight__"
export const HIGHLIGHT_POST_TAG = "__/ais-highlight__"

// Renders a raw Meilisearch _formatted value into text plus <mark> elements.
// <Highlight> already does this for a fixed attribute; this exists for the
// cases where the attribute isn't known until runtime.
export function renderHighlighted(value) {
  if (typeof value !== "string") return null
  if (!value.includes(HIGHLIGHT_PRE_TAG)) return value

  return value.split(HIGHLIGHT_PRE_TAG).flatMap((chunk, chunkIndex) => {
    if (chunkIndex === 0) return chunk ? [chunk] : []

    const [highlighted, ...rest] = chunk.split(HIGHLIGHT_POST_TAG)
    const tail = rest.join(HIGHLIGHT_POST_TAG)

    return [
      <mark key={`highlight-${chunkIndex}`} className="ais-Highlight-highlighted">
        {highlighted}
      </mark>,
      ...(tail ? [tail] : []),
    ]
  })
}
